import script from "./SettingsShiftContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsShiftContent.vue?vue&type=script&setup=true&lang=ts"

import "./SettingsShiftContent.vue?vue&type=style&index=0&id=30f9a4bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30f9a4bc"]])

export default __exports__